module.exports = __webpack_public_path__ + "img/domain.1e2530fc.svg";